export default "__VITE_ASSET__21956543__"